<template>
  <div>
    <Scene14/>
    <Scene15/>
    <Scene16/>
  </div>
</template>

<script>
import { Sprite, Container } from 'pixi.js'
import ChapterMixin from '@/mixins/Chapter'
import Scene14 from './scenes/Scene14'
import Scene15 from './scenes/Scene15'
import Scene16 from './scenes/Scene16'

export default {
  name: 'Senate',
  mixins: [ ChapterMixin ],
  components: { Scene14, Scene15, Scene16 },
}
</script>

